import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { endpoints } from '../api/endpoints';
import { useSession } from './session';

/** Log out, clear the cache and go to the login screen (Menu, galaxy list, registration). */
export function useLogout() {
  const clear = useSession((s) => s.clear);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const mutation = useMutation({
    mutationFn: endpoints.logout,
    onSettled: () => {
      clear();
      queryClient.clear();
      navigate('/login', { replace: true });
    },
  });
  return { logout: () => mutation.mutate(), pending: mutation.isPending };
}
